const ariesConfigs = {
  ariesEnv: "dev",
  baseUrl: "https://api.aries-dev.nabla-mobility.com",
};

export default ariesConfigs;
